export default __webpack_public_path__ + "static/media/cover.02275aea.jpg";